<template>
  <div>
    <b-row class="border-bottom header-row">
      <b-col>
        <a @click.prevent="back" class="backButton" href> <i class="fa fa-caret-left fa-lg"></i>&nbsp; Back to history </a>
      </b-col>
    </b-row>
    <div>
      <b-card-group class="pb-15">
        <b-card no-body class="border-0">
          <div class="reason font-weight-bold" v-if="selectedHistoryItem.revision_no != '1.0'">
            Reason for change: {{ selectedHistoryItem.reason }} {{ new Date(selectedHistoryItem.created_time) | formatUTCDate }} by
            {{ selectedHistoryItem.created_by }}
          </div>
        </b-card>
      </b-card-group>
    </div>

    <div class="mb-30">
      <!-- for Activities  -->
      <div v-if="surveyData.activityId">
        <ParticipantActivityResponsePreview :questionDetailsObj="questionDetailsObj" :questionDetails="questionDetails" :questionDetailsFiltered="questionDetailsFiltered" :mode="'RESPONSE'" :participantResponses="historyDetails" :activityType="surveyData.activityId ? 'activity' : 'survey'" :surveyData="surveyData" :activityLanguageCulture="selectedLanguageCulture" />
      </div>
      <!-- for Legacy Surveys -->
      <div v-else>
        <ParticipantSurveyResponsePreview :participantAnswers="historyDetails" :questionDetailsObj="questionDetailsObj" :mode="'RESPONSE'" :activityType="surveyData.activityId ? 'activity' : 'survey'" :surveyData="surveyData" :activityLanguageCulture="selectedLanguageCulture" />
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantActivityResponsePreview from "./participant-activity-response-preview";
import ParticipantSurveyResponsePreview from "./participant-survey-response-preview";

export default {
  name: "participant-activity-response-history-view",
  data() {
    return {
      questionDetailsFiltered: []
    };
  },
  computed: {
    filteredResponses() {
      if (!this.historyDetails) {
        return [];
      }

      const filteredResponses = this.historyDetails.filter(response => {
        if (response.question_type == "SurveyInstruction") {
          return false;
        }
        return true;
      });

      return filteredResponses;
    }
  },
  mounted() {
    this.filterQuestionDetails();
  },
  methods: {
    back() {
      this.$emit("back");
    },
    filterQuestionDetails() {
      this.questionDetailsFiltered = this.questionDetails.filter(item => {
        return item.type != "Measurements" && item.type != "Index" && item.type != "Log" && item.type != "ValidatedEntry" && item.type != "SurveyCompletion";
      });
    }
  },
  props: {
    surveyId: {
      type: String
    },
    participantResponses: Array,
    questionDetails: Array,
    selectedLanguageCulture: { type: String },
    historyDetails: Array,
    surveyData: Object,
    selectedHistoryItem: {},
    questionDetailsObj: {}
  },
  components: {
    ParticipantActivityResponsePreview,
    ParticipantSurveyResponsePreview
  }
};
</script>

<style scoped>
.header-row {
  padding: 0.9rem 0 0.65rem;
}
.participant-history-image {
  width: 90px;
}
.info {
  font-size: 12px;
  display: inline-block;
}
.reason {
  color: #000000;
  padding-left: 30px;
  padding-top: 19px;
}

.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
  color: #000000;
}

.previous-answer {
  opacity: 0.8;
  color: #000000;
}

.previous-value {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}
</style>
